import { View } from './view';

export const Typography = View;
